import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {StringNode} from "#template/nodes/string/string-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {ValueLikeNode} from "#template/role-markers"
import {valueMarker} from "#template/role-markers"

export type StringValueParameters = {value: string}

const stringValueDefinition: TemplateNodeDefinition<StringValueParameters> = {
    nodeClass: "StringValue",
    validation: {
        parameters: z.object({value: z.string()}),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class StringValue extends StringNode<StringValueParameters> implements ValueLikeNode<string> {
    get [valueMarker]() {
        return true as const
    }

    public override get definition() {
        return stringValueDefinition
    }

    public override evaluate(_scope: GraphBuilderScope, _evaluator: NodeEvaluator): BuilderInlet<string | null> {
        return this.parameters.value
    }
}
